// extracted by mini-css-extract-plugin
export var container = "_fx-0";
export var icon = "_fx-1";
export var text = "_fx-2";